import React, { useEffect } from "react";
import { Account, useAppDispatch, useGetUserApprovalsMutation, GetUserApprovalsApiResponse, GetApproversApiResponse, useGetApproversMutation, RecoveryGroup, MessageHandlerDisplayType, Message, useAppSelector } from "src/common";
import { uiActions, settingsActions, accountActions } from "src/store";
import { RootState } from "src/store/configureStore";

function AccountSettingsComponent(props: { current_account: Account }) {
  const { current_account } = props;
  const dispatch = useAppDispatch();
  const recovery_group = useAppSelector((state: RootState) => state.account.current_account?.recovery_group);
  const [current_recovery_group, setCurrentRecoveryGroup] = React.useState<RecoveryGroup | undefined>(undefined);
  const [getApprovals] = useGetUserApprovalsMutation();
  const [getApprovers] = useGetApproversMutation();

  // Description: First onload event
  useEffect(() => {
    getUserApprovals(false, "pending", true);
    getRecoveryGroup();
  }, []);

  // Description: If the recovery group is not set in the store, set it to the current recovery group
  useEffect(() => {
    if (!recovery_group && current_recovery_group) {
      dispatch(accountActions.setRecoveryGroup(current_recovery_group));
    }
  }, [recovery_group]);

  // Description: Gets user approvals and sets the number of pending approvals in the store
  async function getUserApprovals(history: boolean, status?: string, hide_expired?: boolean, response?: string, limit?: number, offset?: number) {
    if (!!current_account) {
      await getApprovals({ userId: current_account.user_id, status, hideExpired: hide_expired, response, limit, offset })
        .unwrap()
        .then(async (response: GetUserApprovalsApiResponse) => {
          dispatch(settingsActions.setNotifications({ recoveryGroupPending: undefined, recoveryCodePending: undefined, approvals: response.approvals.length }));
      })
      .catch((msg) => {
        dispatch(uiActions.handleRequestErrors(
          new Message(msg, MessageHandlerDisplayType.logger)));
      });
    }
  }

  // Description: Gets the Recovery Group from the backend and creates a new Recovery group object and sets that in the store
  async function getRecoveryGroup() {
    if (!!current_account) {
      await getApprovers({ user_id: current_account.user_id })
        .unwrap()
        .then((params: GetApproversApiResponse) => {
          const recovery_group = new RecoveryGroup(
            params.user_id,
            params.required_users.map((user) => {
              return { name: user.display_name || user.user_id, address: user.user_id };
            }),
            params.optional_users.map((user) => {
              return { name: user.display_name || user.user_id, address: user.user_id };
            }),
            params.optionals_required,
          );
          dispatch(accountActions.setRecoveryGroup(recovery_group));
          setCurrentRecoveryGroup(recovery_group);
        })
        .catch((msg) => {
          dispatch(accountActions.setRecoveryGroup(undefined));
          setCurrentRecoveryGroup(undefined);
          dispatch(uiActions.handleRequestErrors(
            new Message(msg, MessageHandlerDisplayType.logger)),
          );
        });
    }
  }

  return null;
}

export default React.memo(AccountSettingsComponent);
